import React, { useEffect, useState, useContext, useMemo, useCallback } from 'react';
import { useNavigateParams } from '../../../hooks/useNavigateParams';

import { Context } from '../../../context/UserContext';
import Form from './Form';
import styles from '../../form/Form.module.css';

import useFlashMessage from '../../../hooks/useFlashMessage';

import * as EmpresaAPI from '../../../api/empresa';
import CrudsAPI from '../../../api/CRUDs';

import { getEmpresaScope } from '../../../helpers/sessionEmpresa';

const pathname = '/Equipes';

const CreateOrEdit = () => {
    const { empresaId, empresaIds } = getEmpresaScope();

    const [dados, setDados] = useState({
        empresaId,
        ativo: true,
    });
    const [EquipeIntegrantes, setEquipeIntegrantes] = useState([]);

    const [token] = useState(localStorage.getItem('token') || '');
    const [optionsEmpresa, setEmpresa] = useState([]);

    const { parametro } = useContext(Context);
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();

    const urlParams = new URLSearchParams(window.location.search);

    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || (uuid && uuid !== 'null' ? 'Atualizar' : 'Cadastrar');

    const params = useMemo(() => {
        const p = new URLSearchParams();

        if (ul) p.set('ul', ul);
        if (li) p.set('li', li);
        if (tipo) p.set('tipo', tipo);
        if (operacaoUUID) p.set('operacao', operacaoUUID);
        if (uuid) p.set('uuid', uuid);
        if (btnText) p.set('btnText', btnText);

        return p;
    }, [ul, li, tipo, operacaoUUID, uuid, btnText]);

    const tratarErro = useCallback(
        (error, mensagemPadrao = 'Erro ao processar solicitação.') => {
            console.error(error);

            const message = error?.response?.data?.message || mensagemPadrao;
            const type = error?.response?.data?.type || 'error';

            setFlashMessage(message, type);
        },
        [setFlashMessage]
    );

    const consultaEmpresa = useCallback(async () => {
        try {
            const data = await EmpresaAPI.empresa(empresaId);
            setEmpresa(data || []);
        } catch (error) {
            tratarErro(error, 'Erro ao carregar empresas.');
        }
    }, [empresaId, tratarErro]);

    const carregarRegistro = useCallback(async () => {
        if (!uuid || uuid === 'null') return;

        try {
            const response = await CrudsAPI.equipe.consulta(uuid);

            setDados({
                empresaId,
                ativo: true,
                ...(response?.data || {}),
            });

            setEquipeIntegrantes(response?.data?.EquipeIntegrantes || []);
        } catch (error) {
            tratarErro(error, 'Erro ao carregar equipe.');
        }
    }, [uuid, empresaId, tratarErro]);

    useEffect(() => {
        if (!token) {
            navigate('/Auth', { replace: true });
        }
    }, [token, navigate]);

    useEffect(() => {
        consultaEmpresa();
    }, [consultaEmpresa]);

    useEffect(() => {
        carregarRegistro();
    }, [carregarRegistro]);

    async function managerDados(formDados) {
        let urlNavigate = pathname;

        try {
            let response;

            if (uuid && uuid !== 'null') {
                response = await CrudsAPI.equipe.editar(formDados);
            } else {
                response = await CrudsAPI.equipe.cadastrar(formDados);

                if (response.status === 202) {
                    setDados(response.data);

                    response.data.message = 'Registro em duplicidade!';
                    response.data.type = 'warning';

                    urlNavigate = `${pathname}/CreateOrEdit`;
                    params.set('uuid', response.data.uuid);
                    params.set('btnText', 'Atualizar');
                }
            }

            setFlashMessage(response.data.message, response.data.type);

            setTimeout(
                () => {
                    navigate(urlNavigate, params);
                },
                (parametro?.msgTempo || 1) * 1000
            );
        } catch (error) {
            tratarErro(error, 'Erro ao salvar equipe.');
        }
    }

    return (
        <section className={`${styles.form_container} ${styles[parametro?.tema]}`}>
            <Form
                token={token}
                dados={dados}
                setDados={setDados}
                empresaId={empresaId}
                empresaIds={empresaIds}
                handleSubmit={managerDados}
                btnText={btnText}
                optionsEmpresa={optionsEmpresa}
                parametro={parametro}
                caminhoVoltar={pathname}
                EquipeIntegrantes={EquipeIntegrantes}
                setEquipeIntegrantes={setEquipeIntegrantes}
            />
        </section>
    );
};

export default CreateOrEdit;
